<template>
  <div class="int-vacancy-wrap" style="display: block">
    <div class="int-not-vacancy">
      <img src="../../assets/img/rabota/int-vacancy-list.svg" alt="">
      <div class="int-not-vacancy__text">
        <slot>
          {{ $t('vacancy-not') }}
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IntegrationsVacancyListEmpty',
};
</script>

<style lang="scss" scoped>
  .int-not-vacancy {
    width: 100%;
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
    text-align: center;
  img {
    display: inline-block;
    margin-bottom: 1rem;
  }
  &__text {
     width: 13.5rem;
     font-size: 0.9375rem;
     line-height: 1.33;
     color: #091A35;
     opacity: 0.5;
     margin: 0 auto;
   }
  }
</style>

<i18n lang="yml" locale="en">
  vacancy-not: Empty List
</i18n>
<i18n lang="yml" locale="ru">
  vacancy-not: У вас нет открытых вакансий на сайте rabota.ru
</i18n>
